import { NextRouter } from 'next/router'

export const ActivePath = (router: NextRouter, target: string) => {
    if (router?.pathname === target) return true
    else return false
}
